import React, { useState, createContext } from "react";
//import addons from "react-addons/index";
import { Row, Col, Container, Card } from "shards-react";
import RTFCCG from "./Components/RTFCCG";
import { ProtectedRoute } from "../../ProtectedRoute";

//var classSet = React.classSet;


export default function ViewRTFCCG() {
    
         
      return (
      
      <ProtectedRoute>
      <Container className="main-content-container px-4 pb-3">
        <Row noGutters className="page-header py-4">
      </Row>
      <Row noGutters className="px-4">
            <Col>

                <RTFCCG></RTFCCG>


            </Col>
      </Row>
      
        
      
      </Container>
      </ProtectedRoute>
    );
    
    }
/*
export function useViewContext()
{
  return viewContext;
}*/
